import { ROOF_VIRTUAL_ROOM_NAME, type Room } from "building-types/rooms/roomTypes";
import { isInteriorRoomEnclosure, isWalledRoomEnclosure } from "./roomAttributesTools";

export function roomIsEffectivelyExterior(room?: Pick<Room, "attributes">, includeExteriorRooms = true) {
  return (
    !room ||
    (includeExteriorRooms
      ? !isWalledRoomEnclosure[room.attributes.roomEnclosure]
      : !isInteriorRoomEnclosure[room.attributes.roomEnclosure])
  );
}

export function roomIsExterior(room?: Pick<Room, "attributes">) {
  return roomIsEffectivelyExterior(room, false);
}

export function roomProducesInteriorFaces(room?: Pick<Room, "name" | "attributes">): boolean {
  if (!room) {
    return false;
  }
  if (roomIsVirtualRoofRoom(room)) {
    return false;
  }
  return !roomIsEffectivelyExterior(room);
}

export function roomIsVirtualRoofRoom(room?: Pick<Room, "name" | "attributes">): boolean {
  return room?.name === ROOF_VIRTUAL_ROOM_NAME;
}
